import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { useTranslate } from 'lib/tolgee'
import { FeatureFlagsStore } from 'stores'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

import type { ITypeFilterView } from './type-filter.types'

export const useTypeFilterModel = (): ITypeFilterView => {
  const t = useTranslate()
  const location = useLocation()
  const history = useHistory()

  const isIndustryCategoryListEnabled = FeatureFlagsStore.isFeatureFlagEnabled('isIndustryCategoryListEnabled')

  const territoryTypes = useMemo(() => {
    const baseChips = [
      {
        label: t(TOLGEE_GLOBALS.all),
        value: null,
      },
      {
        label: t(TOLGEE_GLOBALS.favorites),
        value: 'favorites',
      },
      {
        label: t(TOLGEE_GLOBALS.topics),
        value: 'topics',
      },
      {
        label: t(TOLGEE_GLOBALS.subtopics),
        value: 'subtopics',
      },
      {
        label: t(TOLGEE_GLOBALS.musicTopics),
        value: 'musicTopics',
      },
      {
        label: t(TOLGEE_GLOBALS.musicSubtopics),
        value: 'musicSubtopics',
      },
      {
        label: t(TOLGEE_GLOBALS.formats),
        value: 'formats',
      },
    ]

    if (isIndustryCategoryListEnabled) {
      return [
        ...baseChips,
        {
          label: t(TOLGEE_GLOBALS.category),
          value: 'brandCategory',
        },
      ]
    }

    return baseChips
  }, [t, isIndustryCategoryListEnabled])

  const territoryTypesValue = useMemo(() => {
    const newSearchParams = new URLSearchParams(location.search)

    const territoryTypesValue = newSearchParams.get('territoryTypes')
    const selectedTerritoryType = territoryTypes.find(item => item.value === territoryTypesValue)

    if (!territoryTypesValue) {
      return null
    }

    return { value: territoryTypesValue, label: selectedTerritoryType?.label }
  }, [location.search, territoryTypes])

  const isTerritoryTypeSelected = Boolean(territoryTypesValue?.value)

  const handleChange = option => {
    const newSearchParams = new URLSearchParams(location.search)
    if (option?.value) {
      newSearchParams.set('territoryTypes', String(option?.value))
    } else {
      newSearchParams.delete('territoryTypes')
    }

    if (option?.value?.includes('music')) {
      newSearchParams.delete('languages')
    }

    //must reset territory filters
    newSearchParams.delete('topics')
    newSearchParams.delete('categories')

    analyticsTracker.eventTrack(analyticsTracker.eventNames.TOP.FILTER_CHIP, {
      selectedChip: option.value || 'all',
    })

    const filterSearchParams = newSearchParams.toString()
    history.push({ search: filterSearchParams })
  }

  return {
    handleChange,
    isTerritoryTypeSelected,
    territoryTypes,
    territoryTypesValue,
  }
}
